<template>
  <div id="sidebar-small">
    <a @click="toggle()" class="logo level">
      <svgicon class="level-item digita" name="menu" height="30" width="30"></svgicon>
    </a>
    <div v-for="section in sections" :key="section.name">
      <div v-for="link in section.links" :key="link.label">
        <router-link
          v-if="link.name"
          class="level"
          :class="{'is-active': name === link.name }"
          :to="{ name: link.name }">
          <svgicon class="level-item link" :name="link.image" height="35" width="35"></svgicon>
        </router-link>
        <a v-else class="level" :href="link.url" target="_">
          <svgicon class="level-item link" :name="link.image" height="35" width="35"></svgicon>
        </a>
      </div>
    </div>
    <a href="https://digitasecurity.com" class="digita-logo level" target="_">
      <svgicon class="level-item" name="shield" width="25" height="25"></svgicon>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SideBarSmall',
  computed: {
    ...mapState('route', ['name']),
  },
  data() {
    return {
      large: true,
    };
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  methods: {
    toggle() {
      this.$emit('update:toggleSideBarSmall');
    },
  },
};
</script>

<style lang="scss" scoped>

a.digita-logo {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px; // Not sure shey the $navbar-height; rem doesn't work here
}

a.digita-logo:hover {
  background-color: $navbar-background;
}

#sidebar-small {
  width: $navbar-height;
  background-color: $navbar-background;
  border-right: 1px solid $border-color;

  a {
    border-bottom: 1px solid $border-color;
    height: $navbar-height;
  }

  a:hover, a.is-active {
    background-color: $sidebar-active;
  }
}


.logo {
  height: $navbar-height;
  border-bottom: 1px solid $border-color;
  text-align: center;
  margin-bottom: 0;
  background-color: $navbar-background;
}

</style>
